"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constant_1 = require("../constant");
const OperatorValue = [...constant_1.ArithmeticOperator, ...constant_1.ComparisonOperator];
